export default __webpack_public_path__ + "static/media/wave_yellow.7fdb48d9.svg";